import { httpAuth } from 'config/apiClient'
import endpoints from 'constants/endpoints'
import { RootState } from 'constants/interfaces'
import { AnyAction } from 'redux'
import { ThunkAction } from 'redux-thunk'
import { AnalyticsData } from 'redux/reducers/analytics'

export const actionTypes = {
  SET_ANALYTICS_DATA: '[ANALYTICS] SET_ANALYTICS_DATA',
  SET_IS_ANALYTICS_LOADING: '[ANALYTICS] SET_IS_ANALYTICS_LOADING',
}

export const setAnalyticsData = (data: AnalyticsData) => ({
  type: actionTypes.SET_ANALYTICS_DATA,
  payload: data,
})

export const setIsAnalyticsLoading = (isLoading: boolean) => ({
  type: actionTypes.SET_IS_ANALYTICS_LOADING,
  payload: isLoading,
})

interface IGetAnalyticsData {
  from_ts?: string
  to_ts?: string
}

export const getAnalyticsData =
  ({ from_ts, to_ts }: IGetAnalyticsData): ThunkAction<void, RootState, unknown, AnyAction> =>
  async (dispatch) => {
    try {
      dispatch(setIsAnalyticsLoading(true))
      const params: IGetAnalyticsData = {
        from_ts,
        to_ts,
      }
      const response = await httpAuth.get(endpoints.analytics, { params })
      dispatch(setAnalyticsData(response.data))
    } catch (error) {
      console.error(error)
    } finally {
      dispatch(setIsAnalyticsLoading(false))
    }
  }
